import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ViableAccountsType } from '../../../core';
import { useLedgerApi } from '../api';

interface TransferCashbackRequest {
  accountType: ViableAccountsType;
  entry: { amount: number };
}

function useTransferCashback() {
  const queryClient = useQueryClient();
  const LedgerApi = useLedgerApi();

  const transferCashback = async ({ accountType, entry }: TransferCashbackRequest) => {
    const { data } = await LedgerApi.post(`/payouts/${accountType}`, { entry });
    return data;
  };
  return useMutation({
    mutationFn: transferCashback,
    onSuccess() {
      return queryClient.invalidateQueries({
        queryKey: ['ledger']
      });
    },
  });
}

export { useTransferCashback };
